/* eslint-disable */
import { getLocalStorageValue } from '../utils/localStorageUtils';
import { CABS_POKUS } from '../utils/pokusContstants';
import { getCookie, getCookieValue } from '../userDetailsUtils';

/* eslint-disable @typescript-eslint/camelcase */
const day = 24 * 60 * 60 * 1000;
const timeOutPromise = async (promise, ms): Promise<Response> => {
  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      console.log('error');
      reject(new Error('promise timeout'));
    }, ms);
    promise.then(
      res => {
        clearTimeout(timeoutId);
        resolve(res);
      },
      err => {
        clearTimeout(timeoutId);
        reject(err);
      }
    );
  });
};
const getCookiesData = (): { deviceId: string; mmtAuth: string } => {
  try {
    const dvid = getCookieValue('dvid') || 'testdevice1';
    const mmtAuth = getCookieValue('mmt-auth') || '';
    
    console.log('>> Cookies - dvid:', dvid, 'mmtAuth:', mmtAuth);
    return { deviceId: dvid, mmtAuth };
  } catch (e) {
    console.error('Error reading cookies:', e);
    return { deviceId: 'testdevice1', mmtAuth: '' };
  }
};
const fetchPokusAndStoreInLS = async (): Promise<any> => {
 
  const { deviceId, mmtAuth } = getCookiesData();
 
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({
      lob: 'CAB',
      user: {
        // userId: 'testUserId1',
        deviceId: deviceId,
        isStickinessEnabled: false,
        mcId: null,
        mmtAuth: mmtAuth
      },
      attributes: {
        device_os: 'pwa'
      }
    })
  };
  try {
    // const pokusResponse = await timeOutPromise(
    //   fetch(
    //     'https://pokus.makemytrip.com/experiment/assignVariant',
    //     requestOptions
    //   ),
    //   500
    // );
    const pokusResponse = await fetch(
      'https://pokus.makemytrip.com/experiment/assignVariant',
      requestOptions
    );
 
    const pokusResponseJson = await pokusResponse.json();
    const expiryTime = new Date().getTime() + 2 * day;
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
      localStorage.setItem(
        CABS_POKUS,
        JSON.stringify({
          data: pokusResponseJson,
          status: 'SUCCESS',
          expiry: expiryTime
        })
      );
    }
    return JSON.stringify({ data: pokusResponseJson, status: 'SUCCESS' });
  } catch (e) {
    return JSON.stringify({ status: 'ERROR' });
  }
};
const getCabsPokusDataFromLocalStorage = (): [boolean, any] => {
  // Check if we're in a browser environment
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
    return [false, null];
  }
  const cabsPokusData = localStorage.getItem(CABS_POKUS);
  return cabsPokusData ? [true, cabsPokusData] : [false, null];
};

const isExpiryTimeOver = expiry => {
  // if no expiry time found fetch again
  if (!expiry) return true;
  // if expiry time is over fetch again
  if (expiry < new Date().getTime()) return true;

  return false;
};

export const getCabsPokusData = async () => {
  let cabsPokusData;
  const [
    cabsPokusPresentInLocalStorage,
    cabsPokusDataFromLocalStorage
  ] = getCabsPokusDataFromLocalStorage();

  // parse cab_pokus data only if it exists
  if (cabsPokusPresentInLocalStorage && cabsPokusDataFromLocalStorage) {
    cabsPokusData = JSON.parse(cabsPokusDataFromLocalStorage);
  }

  if (
    !cabsPokusPresentInLocalStorage ||
    !cabsPokusData ||
    isExpiryTimeOver(cabsPokusData.expiry)
  ) {
    cabsPokusData = await fetchPokusAndStoreInLS();
    cabsPokusData = JSON.parse(cabsPokusData);
  }
  return [cabsPokusPresentInLocalStorage, cabsPokusData];
};

export const getPokusExperimentValue = async (
  pokusExperimentKey: string,
  pokusExperimentDefaultValue: boolean | string = false
) => {
  try {
    const [_, cabsPokusData] = await getCabsPokusData();
    const pokusExperimentValue =
      cabsPokusData?.data?.perLobMap?.CAB?.metadataValues[pokusExperimentKey];
    return pokusExperimentValue;
  } catch (err) {
    console.error(
      `Exception in fetching pokus values for key ${pokusExperimentKey}`,
      err
    );
    return pokusExperimentDefaultValue;
  }
};

export const getPokusValueFromLS = (
  pokusExperimentKey: string,
  defaultValue: boolean | number
) => {
  const cabsPokuData = getLocalStorageValue(CABS_POKUS);
  try {
    if (cabsPokuData != null) {
      const pokusExperimentValue =
        cabsPokuData?.data?.perLobMap?.CAB?.metadataValues[pokusExperimentKey];
      return pokusExperimentValue;
    }
  } catch (err) {
    console.log(
      `Exception in getting pokus values from local storage for pokuskey: ${pokusExperimentKey}`,
      err
    );
  }
  return defaultValue;
};
